export default "__VITE_ASSET__ddf25ff6__"